module.exports = __webpack_public_path__ + "static/img/videoPic3.a00ea398.png";